@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.address-validation-container {
  padding: 15px;

  .validate-button {
    margin-top: 15px;
    display: flex;
    justify-content: center;

    .validate-button-label {
      font-size: 12px;
    }
  }
}

.address-validation-states {
  .address {
    display: inline;
    margin-right: 5px;

    .validated-message {
      flex: 1;
      font-size: 12px;
    }
  }

  .not-validated {
    span {
      color: @orders-drawer--address-validation--not-validated--text-color;
      font-weight: 500;
    }
  }

  .address-validated {
    span {
      color: @orders-drawer--address-validation--validated--text-color;
      font-weight: 500;
    }
  }

  .error {
    span {
      color: @orders-drawer--address-validation--error--text-color;
      font-weight: 500;
    }
  }

  .warning {
    span {
      color: @orders-drawer--address-validation--warning--text-color;
      font-weight: 500;
    }
  }

  .revalidate-message {
    font-size: 12px;
    color: @orders-drawer--address-validation--revalidate--text-color;
    display: inline;
    margin-left: -5px;
  }
}

.progress-bar-section {
  width: 100%;
  height: 20px;
}
